import { useEffect, useRef } from "react";
import { Animated, Easing } from "react-native-web";
import { useEvent, View } from "@tamagui/core";
import { jsx } from "react/jsx-runtime";
const HeightAnimator = ({ isOpen, children }) => {
  const height = useRef(new Animated.Value(0)), setHeight = (toValue) => {
    Animated.timing(height.current, {
      toValue,
      // TODO: see if we can use tokens for animation values
      duration: 100,
      easing: Easing.bezier(0.42, 0, 1, 1),
      useNativeDriver: !1
      // native driver doesn't support animating height
    }).start();
  };
  useEffect(() => {
    isOpen || setHeight(0);
  }, [isOpen]);
  const onLayout = useEvent(({ nativeEvent }) => {
    isOpen && nativeEvent.layout.height && setHeight(nativeEvent.layout.height);
  });
  return /* @__PURE__ */ jsx(Animated.View, { style: { height: height.current }, children: /* @__PURE__ */ jsx(View, { position: "absolute", left: 0, right: 0, onLayout, children }) });
};
export {
  HeightAnimator
};
